module.exports = class EmbedModal {
  async embedModal(embedName) {
    const item   = JSON.parse(localStorage.getItem('itemEmbed') || 'null')
    const paired = JSON.parse(localStorage.getItem('itemEmbedPaired') || 'null')

    if (!item) return { name: embedName, embed: '' }

    const embedHost = (
      (typeof window !== 'undefined' && window.location.origin) ||
      process.env.VUE_APP_HOST_EMBED ||
      process.env.VUE_APP_HOST_TEMPLATE ||
      ''
    ).replace(/\/$/, '')

    // Script unificado: video + chat em um unico arquivo
    const boosterScriptUrl = `${embedHost}/js/booster.min.js`

    // UUID do usuario logado (para ativar o chat junto com o video)
    const userData = JSON.parse(localStorage.getItem('userData') || 'null')
    const userUuid = userData?.uuid || ''

    const isCurrentVertical = item.orientation === 'Vertical'
    const hItem = isCurrentVertical ? paired : item
    const vItem = isCurrentVertical ? item   : paired

    // ── Helper: script loader (unico, no final) ──────────────────────────
    const loaderScript = () =>
      `<script src="${boosterScriptUrl}" data-booster="${userUuid}" async><\/script>`

    // ── Codigo Simplificado (shortcode) ──────────────────────────────────
    // O usuario cola o shortcode onde quer o video, e o script no final da pagina.
    // O booster.min.js encontra o [vid_XXXX] e substitui pelo player automaticamente.
    // O chat aparece automaticamente no canto inferior direito.
    let embedcodeSimple
    if (hItem && vItem) {
      embedcodeSimple =
        `<!-- Coloque onde quer o video -->\n` +
        `<div>[vid_${hItem.id}]</div>\n\n` +
        `<!-- Cole antes do </body> -->\n` +
        loaderScript()
    } else {
      embedcodeSimple =
        `<!-- Coloque onde quer o video -->\n` +
        `<div>[vid_${item.id}]</div>\n\n` +
        `<!-- Cole antes do </body> -->\n` +
        loaderScript()
    }

    // ── Helper: container responsivo (embed completo) ────────────────────
    const container = (vid, frame, paddingBottom, extraStyle = '') =>
      `<div id="vid_${vid}" style="position:relative;width:100%;padding-bottom:${paddingBottom};background:#000;${extraStyle}">` +
      `<img id="thumb_${vid}" src="${frame || ''}" loading="lazy" decoding="async" fetchpriority="low" ` +
      `style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;display:block;" alt=""></div>`

    // ── Helper: script unificado legado (video + chat) ───────────────────
    const loaderScriptLegacy = (scriptId) =>
      `<script type="text/javascript" id="scr_${scriptId}">` +
      `(function(w,r,l,d){` +
      `if(d)w.idbooster=d;` +
      `var s=r.createElement("script");s.src=l;s.type="module";s.async=true;r.head.appendChild(s);` +
      `})(window,document,"${boosterScriptUrl}","${userUuid}");` +
      `<\/script>`

    // ── Codigo JS (completo, com container e thumbnail) ──────────────────
    let embedcodejs
    if (hItem && vItem) {
      const wrapId = `dkp_${hItem.id}`
      embedcodejs =
        `<style>` +
        `#${wrapId} [data-dkp-orient=v]{display:none}` +
        `@media(max-width:768px),screen and (orientation:portrait){` +
        `#${wrapId} [data-dkp-orient=h]{display:none}` +
        `#${wrapId} [data-dkp-orient=v]{display:block}}` +
        `</style>\n` +
        `<div id="${wrapId}">\n` +
        `  <div data-dkp-orient="h">\n    ` +
        container(hItem.id, hItem.vsl_frame, '56.25%') +
        `\n  </div>\n` +
        `  <div data-dkp-orient="v">\n    ` +
        container(vItem.id, vItem.vsl_frame, '177.78%') +
        `\n  </div>\n` +
        `</div>\n` +
        loaderScriptLegacy(wrapId)
    } else {
      const aspect = item.orientation === 'Vertical' ? '177.78%' : '56.25%'
      embedcodejs =
        container(item.id, item.vsl_frame, aspect) + '\n' +
        loaderScriptLegacy(item.id)
    }

    // ── Codigo Iframe ────────────────────────────────────────────────────
    const vidParam  = hItem ? hItem.id : item.id
    const vidVParam = vItem ? vItem.id  : null
    const iframeSrc = `${embedHost}/player/?vid=${vidParam}${vidVParam ? `&vid_v=${vidVParam}` : ''}`

    const embedcodeIframe =
      `<div style="position:relative;width:100%;padding-bottom:56.25%;">` +
      `<iframe src="${iframeSrc}" ` +
      `style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;" ` +
      `frameborder="0" loading="lazy" allow="autoplay;encrypted-media;fullscreen;picture-in-picture" allowfullscreen title="VSL Player">` +
      `</iframe></div>`

    // ── Link direto ──────────────────────────────────────────────────────
    const embedcodeLink = iframeSrc

    if (embedName === 'Codigo Simples')  return { name: 'Codigo Simples',  embed: embedcodeSimple }
    if (embedName === 'Código Simples')  return { name: 'Código Simples',  embed: embedcodeSimple }
    if (embedName === 'Código JS')       return { name: 'Código JS',       embed: embedcodejs }
    if (embedName === 'Codigo JS')       return { name: 'Codigo JS',       embed: embedcodejs }
    if (embedName === 'Código Iframe')   return { name: 'Código Iframe',   embed: embedcodeIframe }
    if (embedName === 'Codigo Iframe')    return { name: 'Codigo Iframe',   embed: embedcodeIframe }
    if (embedName === 'Link')            return { name: 'Link',            embed: embedcodeLink }

    // Default: retorna o simples
    return { name: embedName, embed: embedcodeSimple }
  }
}
